import { ReactComponent as Logo } from "../../assets/svg/logo.svg";
import { useTranslation } from "react-i18next";
import useStyles from "./styles";
import { CustomTypography } from "../../components/CustomTypography/CustomTypography";
import { CustomTextField } from "../../components/CustomTextField/CustomTextField";
import { CustomButton } from "../../components/CustomButton/CustomButton";
import { useState } from "react";
import toast from "react-hot-toast";
import { useConfirmUpdatePassword } from "../../api/user";
import {
  describePolicy,
  usePasswordPolicy,
  validatePassword,
} from "../../api/passwordPolicy";
import { useLocation } from "react-router";

type Props = {};

export const ForgotPassword: React.FC<Props> = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const idUser = queryParams.get("idUser");

  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const { mutate: updateUser, isPending } = useConfirmUpdatePassword();
  const passwordPolicy = usePasswordPolicy();

  /*
   * ── LE CONTROLE ETAIT PRESQUE ABSENT ────────────────────────────────────
   *
   * Cet ecran est la DERNIERE etape du parcours "mot de passe oublie" : c'est
   * ici que le compte recoit ses nouveaux identifiants. Il ne verifiait qu'une
   * seule chose :
   *
   *     const format = /[`!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?~]/;
   *     if (!format.test(password)) { ... }
   *
   * La presence d'un symbole. Pas la longueur, pas la casse, pas le chiffre --
   * alors que le message d'erreur affiche, lui, enoncait les quatre. "a!" etait
   * donc accepte, et le serveur derriere PUT /user/update ne validait rien du
   * tout. Pendant ce temps l'ecran d'invitation, lui, exigeait les quatre : le
   * meme compte pouvait obtenir un mot de passe fort ou trivial selon la porte
   * empruntee.
   *
   * Les deux ecrans lisent desormais la meme politique, et le serveur
   * l'applique (config/security.php).
   *
   * L'ordre des controles change aussi : deux champs vides tombaient dans le
   * `else` et declenchaient l'erreur de format, qui ne decrit pas le probleme.
   */
  const handleConfirm = () => {
    if (password.length === 0) {
      toast.error(t("required.checkFields", "All fields are required"));
      return;
    }
    if (!validatePassword(password, passwordPolicy)) {
      toast.error(describePolicy(t, passwordPolicy));
      return;
    }
    if (password !== passwordConfirm) {
      toast.error(t("login.errorConfirm", "Passwords do not match"));
      return;
    }

    updateUser({ id: idUser ? Number(idUser) : -1, password });
  };

  return (
    <div className={classes.container}>
      <Logo className={classes.logo} />
      <CustomTypography
        variant="link"
        textDecoration={"none"}
        styles={{ containerText: classes.text }}
        text={t(
          "login.chooseNewPassword",
          "Choose your new password, then click Validate."
        )}
      />
      <div className={classes.subContainer}>
        <CustomTextField
          placeholder={t("login.password", "Password")}
          type={"password"}
          pass
          fullWidth={true}
          onChange={(e) => setPassword(e.target.value)}
        />
        {/* Les exigences avant la saisie, plutot que revelees par un refus. */}
        <CustomTypography
          variant="link"
          textDecoration={"none"}
          styles={{ containerText: classes.text }}
          text={describePolicy(t, passwordPolicy)}
        />
        <CustomTextField
          placeholder={t("login.confirmPassword", "Confirm password")}
          type={"password"}
          pass
          fullWidth={true}
          onChange={(e) => setPasswordConfirm(e.target.value)}
        />
        <div className={classes.subContainer2}>
          <CustomButton
            onClick={handleConfirm}
            height={"40px"}
            variant={"white"}
            label={t("login.newPassword", "VALIDATE")}
            loading={isPending}
          />
        </div>
      </div>
    </div>
  );
};
